import { render, staticRenderFns } from "./CommentChanges.vue?vue&type=template&id=aa683f2a"
import script from "./CommentChanges.vue?vue&type=script&lang=js"
export * from "./CommentChanges.vue?vue&type=script&lang=js"
import style0 from "./CommentChanges.vue?vue&type=style&index=0&id=aa683f2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports